// extracted by mini-css-extract-plugin
export default {"card":"mapasCards_card__UQ596","cardContent":"mapasCards_cardContent__hAMjU","icon":"mapasCards_icon__2zDcH"};